import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const outcomes = [{
  layer: 'Masterclass Intro',
  serves: 'Clinician authority + engagement',
  impact: 'Cinematic introduction of the featured clinician and the clinical challenge'
}, {
  layer: 'The Clinical Core',
  serves: 'Practitioner enablement + Clinician authority',
  impact: 'Diagnosis → technique → outcome. Solventum appears naturally where it helped solve the case'
}, {
  layer: 'X-Ray Overlay',
  serves: 'All three audiences',
  impact: 'On-demand context: clinician CV, technique notes, materials used, downloadable assets'
}, {
  layer: 'The Case Library',
  serves: 'Practitioner enablement',
  impact: 'Browse by clinician or by clinical challenge — practitioners choose the case relevant to them'
}];
export function TheJourney() {
  return <section className="py-24 bg-white" data-id="element-520">
      <div className="max-w-6xl mx-auto px-6" data-id="element-521">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-522">
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-solventum-dark mb-4" data-id="element-523">
            The Experience
          </h2>
          <p className="text-xl text-solventum-dark/60 max-w-3xl mx-auto" data-id="element-524">
            Four layers that guide practitioners from inspiration to applied
            clinical learning
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-525">
          {outcomes.map((outcome, index) => <motion.div key={outcome.layer} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-solventum-lightTeal/30 rounded-xl p-6 border border-solventum-gray hover:border-solventum-teal/50 transition-colors" data-id="element-526">
              <div className="flex items-start gap-4" data-id="element-527">
                <div className="w-10 h-10 rounded-full bg-solventum-dark flex items-center justify-center flex-shrink-0" data-id="element-528">
                  <CheckCircle2 className="w-6 h-6 text-solventum-green" data-id="element-529" />
                </div>
                <div className="flex-1" data-id="element-530">
                  <div className="flex items-center gap-3 mb-2 flex-wrap" data-id="element-531">
                    <h3 className="text-xl font-bold text-solventum-dark" data-id="element-532">
                      {outcome.layer}
                    </h3>
                    <ArrowRight className="w-5 h-5 text-solventum-dark/40" data-id="element-533" />
                    <span className="text-sm font-semibold text-solventum-teal" data-id="element-534">
                      {outcome.serves}
                    </span>
                  </div>
                  <p className="text-solventum-dark/70" data-id="element-535">{outcome.impact}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}